import {useEffect,useRef} from "react";

const useWindowResized = (cb) => {

    const resizeEvt = useRef();

    const handle = e => {

        clearTimeout(resizeEvt.current);
        resizeEvt.current = setTimeout(() => {
            cb(e);
        }, 500)

    }

    useEffect(() => {

        handle()

        window.addEventListener('resize', handle);
        return () => {
            window.removeEventListener('resize', handle);
        }
    })
}

export default useWindowResized